<template>
  <div>
    <div class="padding noise">
      <section class="about">
        <div class="container">
          <div class="row">
            <div class="col-9">
              <h1 class="typed section-heading">Hello</h1>
              <p class="section-content">
                <strong>I — </strong> My name is Ujjwal Verma, I am an Indian
                and I live in New Delhi, India. <strong>II — </strong>I design
                digital graphics & retouch photos that brands use as home decor
                & advertisements. <strong>III — </strong> I help businesses from
                around the globe to grow with their exquisite spaces.
                <strong>IV — </strong> I am a nature lover, I love talking to
                the moon eye to eye. <strong>V — </strong> I appreciate
                everyone's work, everyone has a creative mind. You just need to
                see it. <strong>VI — </strong> I haven't yet started capturing
                my thoughts on canvas. I create surreal artworks because I love
                doing those. <strong>VII — </strong> Dreaming is a gift which is
                why I sleep more. <strong>VIII — </strong> I love winters,
                summer is something that I don't like <strong>IX — </strong> I
                want to create a Magical world, something very wonderful. I
                still don't know how and when, but I promise I will.
                <small>
                  I have a hunger to take products and businesses to next level,
                  looking for a creative collaboration? Tell me what you need
                  and magic will happen. Connect to me at
                  <em
                    ><a href="mailto:ujjwallverma@gmail.com"
                      >ujjwallverma@gmail.com</a
                    ></em
                  >
                </small>
              </p>
            </div>
            <div class="col-7 about-photo">
              <img src="/img/ujjwal.jpg" alt="" />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="about">
          <div class="container">
            <div class="row">
              <h2 class="">Let's talk about Skills</h2>
              <div class="skill">
                <div class="col-8 padding-zero-bottom-m">
                  <ul style="list-style-type: none">
                    <li>
                      <a class="Photoshop icon">Photoshop</a>
                      <div class="bar">
                        <div
                          class="photoshop-bar mark-bar"
                          style="width: 90%"
                        ></div>
                      </div>
                    </li>

                    <li>
                      <a class="lightroom icon">Lightroom</a>
                      <div class="bar">
                        <div
                          class="lightroom-bar mark-bar"
                          style="width: 90%"
                        ></div>
                      </div>
                    </li>
                    <li>
                      <a class="illustrator icon">Illustrator</a>
                      <div class="bar">
                        <div
                          class="illustrator-bar mark-bar"
                          style="width: 60%"
                        ></div>
                      </div>
                    </li>
                    <li>
                      <a class="premierepro icon">Premiere Pro</a>
                      <div class="bar">
                        <div
                          class="premierepro-bar mark-bar"
                          style="width: 30%"
                        ></div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="col-8 padding-zero-top-m">
                  <ul style="list-style-type: none">
                    <li>
                      <a class="aftereffects icon">After Effects</a>
                      <div class="bar">
                        <div
                          class="aftereffects-bar mark-bar"
                          style="width: 60%"
                        ></div>
                      </div>
                    </li>
                    <li>
                      <a class="adobexd icon">Adobe XD</a>
                      <div class="bar">
                        <div
                          class="adobexd-bar mark-bar"
                          style="width: 70%"
                        ></div>
                      </div>
                    </li>
                    <li>
                      <a class="c4d icon">Cinema 4D</a>
                      <div class="bar">
                        <div class="c4d-bar mark-bar" style="width: 30%"></div>
                      </div>
                    </li>
                    <li>
                      <a class="code icon">HTML & CSS</a>
                      <div class="bar">
                        <div class="code-bar mark-bar" style="width: 50%"></div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="about">
          <div class="container">
            <div class="row">
              <div class="col-9">
                <h2 class="">Stay creative through practice</h2>
                <p class="section-content">
                  Quick, short, speed up process, how I combine photographs and
                  brushes, apply textures, create light-leaks and other blending
                  elements, mix the objects on a suitable vibrant background,
                  and put it together perfectly, added depth and bokeh.
                  Eventually, adjusted the overall colors and lighting. And
                  voila! Walked into my own surreal world.
                </p>
              </div>
              <div class="col-7">
                <div class="dell dell-inner">
                  <!-- <iframe width="1519" height="538" src="https://www.youtube.com/embed/HNYhLGZzTn0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
                  <iframe
                    class="dell-screen"
                    title="youtube Video Player"
                    src="https://www.youtube.com/embed/HNYhLGZzTn0?feature=oembed&amp; wmode=opaque&amp;loop=0&amp;controls=0&amp;mute=1&amp;rel=0&amp;modestbranding=0&amp;autoplay=1"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="about">
          <div class="container">
            <div class="row">
              <div class="col-3"></div>
              <div class="col-10 float-none">
                <h2 class="" style="text-align: center">
                  What people are saying...<br />and work with
                </h2>
                <div class="saying">
                  <div class="row"><div class="back-space" id="foo"></div></div>
                  <div class="row" onclick="myFunction()" id="demo">
                    <div class="col-4">
                      <div class="company-logo-outer">
                        <div class="lemontree company-logo"></div>
                      </div>
                    </div>
                    <div class="col-12 margin-left">
                      <div class="section-content">
                        <h3>Sareena Kochar</h3>
                        <small style="margin: 0px"
                          >VP, Lemon Tree <span class="red"> Client</span>
                        </small>
                        <small>
                          &#10077; Ujjwal is associated with us since 1st May
                          2015. he is most creative editor who works promptly on
                          our day today requirements. He is disciplined and time
                          bound. He had handled all assignments in detailed
                          manner. We recommend him for his bright future
                          &#10078;
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3"></div>
            </div>
            <div class="company-logo-mobile">
              <div class="companys-logo-outer ccb-position">
                <div class="ccb companys-logo"></div>
              </div>
              <div class="companys-logo-outer hyatt-position">
                <div class="hyatt companys-logo"></div>
              </div>
              <div class="companys-logo-outer fairfield-marriott-position">
                <div class="fairfield-marriott companys-logo"></div>
              </div>
              <div class="companys-logo-outer redfox-position">
                <div class="redfox companys-logo"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="about gardient-background">
          <div class="container">
            <div class="row">
              <!-- <div class="col-16">
                    <a class="resume-dark icon">Premiere Pro</a>
                </div> -->
              <div class="col-7">
                <h2 class="" style="color: #fff">Hire me</h2>
                <p class="resume-text">
                  I have a hunger to take products and businesses to next level,
                  looking for a creative collaboration? Tell me what you need
                  and magic will happen. Connect to me at
                  <em
                    ><a style="color: #fff" href="mailto:hello@ujjwalverma.com"
                      >hello@ujjwalverma.com</a
                    ></em
                  >
                  or simply
                  <em
                    ><a style="color: #fff" href="tel:+91-9999160190"
                      >Call me</a
                    ></em
                  >. <br />
                  <small
                    ><em
                      ><a style="color: #fff" href="/img/resume.pdf" download
                        >Download <span class="">Resume</span>
                      </a></em
                    ></small
                  >
                </p>
              </div>
              <div class="col-9 about-photo">
                <a href="/img/resume.pdf" download>
                  <img class="remove-boxshoadow" src="/img/resume.png" alt="" />
                </a>
                <!-- <div class="resume-dark"></div> -->
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>
